import { Colors, ColorsOrShades } from '../../styles/theme';
import { ButtonColors } from './JRCButton';

export const defaultLinkStyle: ButtonType = {
    color: 'primary',
    background: 'transparent',
    border: 'transparent',
    active: {
        background: 'transparent',
        border: 'transparent',
        'text-decoration': 'underline',
    },
    hover: {
        background: 'transparent',
        border: 'transparent',
        'text-decoration': 'underline',
    },
};

export type ButtonType = {
    color: Colors;
    background: ColorsOrShades;
    border: Colors;
    active: {
        background: ColorsOrShades;
        border: ColorsOrShades;
        'text-decoration'?: 'underline' | 'none';
    };
    hover: {
        background: ColorsOrShades;
        border: ColorsOrShades;
        'text-decoration'?: 'underline' | 'none';
    };
};
type ButtonConfig = Record<'contained' | 'outlined', Record<ButtonColors | 'disabled', ButtonType>> &
    Record<'link', Record<ButtonColors | 'disabled', ButtonType>>;

export const BUTTON_CONFIG: ButtonConfig = {
    contained: {
        primary: {
            color: 'white',
            background: 'primary',
            border: 'primary',
            active: {
                background: 'primaryD20',
                border: 'primaryD20',
            },
            hover: {
                background: 'primaryL15',
                border: 'primaryL15',
            },
        },
        valid: {
            color: 'white',
            background: 'green',
            border: 'green',
            active: {
                background: 'greenD20',
                border: 'greenD20',
            },
            hover: {
                background: 'greenL20',
                border: 'greenL20',
            },
        },
        danger: {
            color: 'white',
            background: 'orange',
            border: 'orange',
            active: {
                background: 'orangeD20',
                border: 'orangeD20',
            },
            hover: {
                background: 'orangeL15',
                border: 'orangeL15',
            },
        },
        secondary: {
            color: 'white',
            background: 'secondary',
            border: 'secondary',
            active: {
                background: 'secondaryD20',
                border: 'secondaryD20',
            },
            hover: {
                background: 'secondaryL15',
                border: 'secondaryL15',
            },
        },
        cancel: {
            color: 'grey6',
            background: 'grey1',
            border: 'grey1',
            active: {
                background: 'grey3',
                border: 'grey3',
            },
            hover: {
                background: 'grey2',
                border: 'grey2',
            },
        },
        neutral: {
            color: 'grey5',
            background: 'white',
            border: 'white',
            active: {
                background: 'grey2',
                border: 'grey2',
            },
            hover: {
                background: 'grey1',
                border: 'grey1',
            },
        },
        white: {
            color: 'grey5',
            background: 'white',
            border: 'white',
            active: {
                background: 'grey2',
                border: 'grey2',
            },
            hover: {
                background: 'grey1',
                border: 'grey1',
            },
        },
        disabled: {
            color: 'grey3',
            background: 'grey1',
            border: 'grey1',
            active: {
                background: 'grey1',
                border: 'grey1',
            },
            hover: {
                background: 'grey1',
                border: 'grey1',
            },
        },
    },
    outlined: {
        primary: {
            color: 'primary',
            background: 'transparent',
            border: 'primary',
            active: {
                background: 'primaryL80',
                border: 'primary',
            },
            hover: {
                background: 'primaryL90',
                border: 'primary',
            },
        },
        valid: {
            color: 'green',
            background: 'transparent',
            border: 'green',
            active: {
                background: 'greenL80',
                border: 'green',
            },
            hover: {
                background: 'greenL90',
                border: 'green',
            },
        },
        danger: {
            color: 'orange',
            background: 'transparent',
            border: 'orange',
            active: {
                background: 'orangeL80',
                border: 'orange',
            },
            hover: {
                background: 'orangeL90',
                border: 'orange',
            },
        },
        secondary: {
            color: 'secondary',
            background: 'transparent',
            border: 'secondary',
            active: {
                background: 'secondaryL80',
                border: 'secondary',
            },
            hover: {
                background: 'secondaryL90',
                border: 'secondary',
            },
        },
        cancel: {
            color: 'grey4',
            background: 'transparent',
            border: 'grey4',
            active: {
                background: 'grey2',
                border: 'grey4',
            },
            hover: {
                background: 'grey1',
                border: 'grey4',
            },
        },
        neutral: {
            color: 'grey5',
            background: 'transparent',
            border: 'grey5',
            active: {
                background: 'grey2',
                border: 'grey4',
            },
            hover: {
                background: 'grey1',
                border: 'grey4',
            },
        },
        white: {
            color: 'white',
            background: 'transparent',
            border: 'white',
            active: {
                background: 'grey5',
                border: 'white',
            },
            hover: {
                background: 'grey4',
                border: 'white',
            },
        },
        disabled: {
            color: 'grey3',
            background: 'white',
            border: 'grey3',
            active: {
                background: 'white',
                border: 'grey3',
            },
            hover: {
                background: 'white',
                border: 'grey3',
            },
        },
    },
    link: {
        primary: { ...defaultLinkStyle },
        valid: {
            ...defaultLinkStyle,
            color: 'green',
        },
        danger: {
            ...defaultLinkStyle,
            color: 'orange',
        },
        secondary: {
            ...defaultLinkStyle,
            color: 'secondary',
        },
        cancel: {
            ...defaultLinkStyle,
            color: 'grey4',
        },
        disabled: {
            ...defaultLinkStyle,
            color: 'grey3',
        },
        neutral: {
            ...defaultLinkStyle,
            color: 'grey5',
        },
        white: {
            ...defaultLinkStyle,
            color: 'white',
        },
    },
};
